export default function init(axios, cookies, router, i18n) {
    var instance = axios.create({
        baseURL: process.env.VUE_APP_API_BACKEND,
        headers: {
            'Accept': 'application/json',
        },
    });

    instance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (!error.response) {
                return Promise.reject({
                    response: {
                        data: {
                            message: i18n.global.t('basic.alert.network_error')
                        },
                    }
                });
            }

            if (error.response.data.status == 401) {
                cookies.remove('api_token', '/');

                const currentRoute = router.currentRoute.value;

                // pakai redirectFrom lama kalau sudah ada
                const redirectFrom = currentRoute.query.redirectFrom
                    ? currentRoute.query.redirectFrom
                    : currentRoute.fullPath;

                router.push({
                    name: 'login',
                    query: { redirectFrom }
                });
            }

            if (error.response.data.status == 403 && error.response.data.error == "VERIFY_EMAIL") {
                router.push({
                    name: 'verify-email',
                });
            }

            if (error.response.data.status == 403 && error.response.data.error == "VERIFY_SESSION") {
                router.push({
                    name: 'verify-session',
                });
            }

            return Promise.reject(error);
        }
    );

    return instance;
}
